import { gql } from '@apollo/client';

export const CREATE_CUSTOMER_MUTATION = gql`
  mutation CreateCustomer($name: String!, $email: String, $phone: String, $domainId: Int!, $commissionUpchargePercent: BigFloat) {
    createCustomer(input: { customer: { name: $name, email: $email, phone: $phone, domainId: $domainId, commissionUpchargePercent: $commissionUpchargePercent } }) {
      customer {
        id
        name
        email
        phone
        domainId
        commissionUpchargePercent
      }
    }
  }
`;

export const CREATE_ADDRESS_MUTATION = gql`
  mutation CreateAddress($customerId: Int!, $domainId: Int!, $street: String!, $city: String!, $state: String!, $zip: String!, $addressType: String!) {
    createAddress(input: { address: { customerId: $customerId, domainId: $domainId, street: $street, city: $city, state: $state, zip: $zip, addressType: $addressType } }) {
      address {
        id
        customerId
        street
        city
        state
        zip
        addressType
      }
    }
  }
`;

export const ALL_CUSTOMERS_QUERY = gql`
  query AllCustomers($domainId: Int!) {
    allCustomers(condition: { domainId: $domainId }) {
      nodes {
        id
        name
        email
        phone
        commissionUpchargePercent
        archivedAt
        createdAt
        addressesByCustomerId {
          nodes {
            id
            street
            city
            state
            zip
            addressType
          }
        }
      }
    }
  }
`;

export const CUSTOMER_BY_ID_QUERY = gql`
  query CustomerById($id: Int!) {
    customerById(id: $id) {
      id
      name
      email
      phone
      commissionUpchargePercent
      archivedAt
      addressesByCustomerId {
        nodes {
          id
          street
          city
          state
          zip
          addressType
        }
      }
      jobsByCustomerId(orderBy: CREATED_AT_DESC) {
        nodes {
          id
          name
          status
          createdAt
          archivedAt
        }
      }
    }
  }
`;

export const UPDATE_CUSTOMER_ARCHIVE_MUTATION = gql`
  mutation UpdateCustomerArchive($id: Int!, $archivedAt: Datetime) {
    updateCustomerById(input: { id: $id, customerPatch: { archivedAt: $archivedAt } }) {
      customer {
        id
        archivedAt
      }
    }
  }
`;

export const UPDATE_CUSTOMER_COMMISSION_MUTATION = gql`
  mutation UpdateCustomerCommission($id: Int!, $commissionUpchargePercent: BigFloat) {
    updateCustomerById(input: { id: $id, customerPatch: { commissionUpchargePercent: $commissionUpchargePercent } }) {
      customer {
        id
        commissionUpchargePercent
      }
    }
  }
`;
